"use client";

import { useEffect, useRef } from "react";
import { usePathname, useRouter } from "next/navigation";
import { Button } from "@/components/ui/button";
import { Text } from "@/components/ui/text";
import { Home, ArrowLeft } from "lucide-react";
import { captureRouteNotFoundPage } from "@/lib/analytics";

export default function NotFound() {
  const router = useRouter();
  const pathname = usePathname();
  const captured = useRef(false);

  useEffect(() => {
    if (captured.current) return;
    captured.current = true;
    const search =
      typeof window !== "undefined"
        ? window.location.search.replace(/^\?/, "")
        : "";
    captureRouteNotFoundPage("app", {
      pathname: pathname || "/",
      search,
    });
  }, [pathname]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background px-4">
      <div className="max-w-md w-full text-center space-y-6">
        <div className="space-y-2">
          <Text as="h1" size="2xl" weight="bold" color="default" className="text-6xl">
            404
          </Text>
          <Text as="h2" size="xl" weight="semibold" color="default">
            Page Not Found
          </Text>
          <Text as="p" size="base" weight="normal" color="muted" className="mt-4">
            The page you're looking for doesn't exist or has been moved.
          </Text>
        </div>

        <div className="flex flex-col sm:flex-row gap-3 justify-center items-center pt-4">
          <Button
            onClick={() => router.back()}
            variant="secondary"
            className="gap-2"
          >
            <ArrowLeft className="w-4 h-4" />
            Go Back
          </Button>
          <Button
            onClick={() => router.push("/")}
            variant="default"
            className="gap-2"
          >
            <Home className="w-4 h-4" />
            Go Home
          </Button>
        </div>
      </div>
    </div>
  );
}

